'use client';

import React, { PropsWithChildren, useMemo, JSX } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material';
import { createAppTheme } from '@/config';
import { useLocale } from '@ianesthesie-kit/core';

export const ThemeProvider = ({
  children
}: PropsWithChildren<unknown>): JSX.Element => {
  const locale = useLocale();

  const appTheme = useMemo(() => createAppTheme(locale), [locale]);

  return <MuiThemeProvider theme={appTheme}>{children}</MuiThemeProvider>;
};
